var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-circle __container",style:({
    width: (_vm.outerSquare + "px"),
    height: (_vm.outerSquare + "px"),
    boxShadow: _vm.boxShadow,
  })},[_c('div',{staticClass:"progress-circle __inner-shadow",style:({
      height: (_vm.innerSquare + "px"),
      width: (_vm.innerSquare + "px"),
      marginTop: ("-" + ((_vm.innerSquare)/2) + "px"),
      marginLeft: ("-" + ((_vm.innerSquare)/2) + "px"),
      boxShadow: _vm.innerBoxShadow,
    })}),_c('svg',{staticClass:"progress-circle __svg",attrs:{"width":_vm.outerSquare,"height":_vm.outerSquare,"version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{staticClass:"progress-circle __inner-circle",style:({ stroke: _vm.innerCircleColor, strokeWidth: (_vm.ringWidth + "px") }),attrs:{"r":_vm.radius,"cx":_vm.centerPoint,"cy":_vm.centerPoint,"fill":"transparent","stroke-dasharray":_vm.circumference}}),_c('circle',{staticClass:"progress-circle __bar",style:({
        stroke: _vm.progressBarColor,
        strokeWidth: (_vm.ringWidth + "px"),
        strokeDashoffset: _vm.strokeDashoffset,
        transition: ("stroke-dashoffset " + _vm.animationDuration + "s cubic-bezier(0.4, 0, 0.2, 1)"),
        background: 'red'
      }),attrs:{"r":_vm.radius,"cx":_vm.centerPoint,"cy":_vm.centerPoint,"fill":"transparent","stroke-dasharray":_vm.circumference}})]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }